import { Component, OnInit } from "@angular/core";
import { NzMessageService } from "ng-zorro-antd/message";
import { catchError } from "rxjs";
import { HttpCommunicationService } from "../../../service/http-communication.service";
import { NotificationBulkLogDto } from "../../../service/dto";
import { NzTableQueryParams } from "ng-zorro-antd/table";
import { Router } from "@angular/router";

@Component({
	selector: 'app-communication-log',
	standalone: false,
	templateUrl: './communication-log.component.html',
	styleUrl: './communication-log.component.scss'
})
export class CommunicationLogComponent implements OnInit {

	logs!: NotificationBulkLogDto[];
	loading = false;
	total = 0;
	pageSize = 10;
	pageIndex = 1;

	constructor(
		private message: NzMessageService,
		private router: Router,
		private httpService: HttpCommunicationService) {}

	ngOnInit(): void {
		this.fetchLog();
	}

	getThis(): CommunicationLogComponent {
		return this;
	}
	
	onQueryParamsChange(params: NzTableQueryParams, that: CommunicationLogComponent): void {
		const { pageIndex, pageSize } = params;
		if (pageIndex == that.pageIndex && pageSize == that.pageSize) {
			return;
		}
		that.pageIndex = pageIndex;
		that.pageSize = pageSize;

		this.fetchLog();
	}

	private fetchLog() {
		this.loading = true;
		this.httpService.getLog(this.pageIndex, this.pageSize)
		.pipe(
			catchError(error => {
				console.log('Error fetching communication log', error);
				this.message.error('Failed to fetch communication log');
				throw error;
			})
		)
		.subscribe({
			next: (res) => {
				this.loading = false;
				this.logs = res.list;
				this.total = res.totalItems;
				this.pageIndex = res.pageIndex;
				this.pageSize = res.pageSize;
			},
			error: () => {
				this.loading = false;
			},
		});
	}

	viewReport(input: NotificationBulkLogDto) {
		this.router.navigate(['/communication/report', input.id]);
	}

}